export const DOG_BREEDS = [
  'Akbaş', 'Akita Inu', 'Alaskan Malamute', 'Alman Çoban Köpeği', 'Alman Kurdu',
  'American Bully', 'American Staffordshire Terrier', 'Amerikan Cocker Spaniel',
  'Anadolu Çoban Köpeği (Kangal)', 'Basset Hound', 'Beagle', 'Bichon Frise',
  'Boksör (Boxer)', 'Border Collie', 'Boston Terrier', 'Briard',
  'Bull Terrier', 'Bulldog (İngiliz)', 'Bulldog (Fransız)',
  'Cane Corso', 'Cavalier King Charles', 'Chihuahua', 'Chow Chow',
  'Cocker Spaniel', 'Corgi (Pembroke)', 'Corgi (Cardigan)',
  'Çoban Köpeği (Belçika Malinois)', 'Dalmaçyalı', 'Doberman',
  'Dogo Argentino', 'Golden Retriever', 'Great Dane (Danua)',
  'Havanese', 'Husky (Sibirya)', 'Irish Setter',
  'İngiliz Setter', 'İtalyan Greyhound', 'Jack Russell Terrier',
  'Kangal', 'Karabaş', 'Labrador Retriever', 'Lhasa Apso',
  'Maltese Terrier', 'Mastiff (İngiliz)', 'Miniature Pinscher',
  'Miniature Schnauzer', 'Newfoundland', 'Papillon',
  'Pekingese', 'Pit Bull Terrier', 'Pointer (Alman)',
  'Pomeranian', 'Poodle (Kaniş)', 'Pug (Mops)',
  'Rottweiler', 'Saint Bernard', 'Samoyed',
  'Scottish Terrier', 'Shar Pei', 'Shiba Inu',
  'Shih Tzu', 'Springer Spaniel', 'Staffordshire Bull Terrier',
  'Terrier', 'Vizsla', 'Weimaraner',
  'West Highland White Terrier', 'Whippet', 'Yorkshire Terrier',
  'Melez', 'Diğer',
];

export const CAT_BREEDS = [
  'Abesinia (Abyssinian)', 'Amerikan Bobtail', 'Amerikan Kısa Tüylü',
  'Ankara Kedisi (Turkish Angora)', 'Bengal', 'Birman (Kutsal Burma)',
  'Bombay', 'British Longhair', 'British Shorthair',
  'Burma Kedisi (Burmese)', 'Chartreux', 'Devon Rex',
  'Exotic Shorthair', 'Himalaya', 'İran Kedisi (Persian)',
  'İskoç Kıvrık Kulaklı (Scottish Fold)', 'Japon Bobtail',
  'Maine Coon', 'Mavi Rus (Russian Blue)', 'Mısır Mau',
  'Munchkin', 'Norveç Orman Kedisi', 'Ocicat',
  'Ragdoll', 'Rex (Cornish)', 'Savannah',
  'Selkirk Rex', 'Siyam Kedisi (Siamese)', 'Somali',
  'Sphynx', 'Tonkinese', 'Türk Van Kedisi',
  'Van Kedisi', 'Melez', 'Diğer',
];
